import React from 'react';
import { TextArea } from '..';

import { FlexCol } from '../FlexCol';

export const CommaInput = ({ item, placeholder = 'Separate by commas.', className = '', onChangeItem = () => {} }) => {
  return (
    <FlexCol className={'items-center lg:flex-row w-full flex-1 ' + className}>
      <TextArea
        className="flex-1 w-full"
        type={item.type}
        placeholder={placeholder}
        value={item.value}
        containerClassName="w-full"
        onChange={(value) => onChangeItem({ ...item, value })}
      />
    </FlexCol>
  );
};
